import { useContext } from "react"

import ListItem from "@mui/material/ListItem"
import { styled } from "@mui/material/styles"
import { MapContext } from "../../MapContextProvider"
import DeviceLabel from "./DeviceLabel/DeviceLabel"
import DeviceStatus from "./DeviceStatus"
import theme from "css/theme/light"

const StyledListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== "isActive"
})(({ isActive }) => ({
  padding: "0px 8px 2px 8px",
  borderRadius: 6,

  ...(isActive && {
    backgroundColor: theme.palette.secondary[100]
  }),

  "&:hover": {
    borderRadius: "6px !important",
    backgroundColor: theme.palette.grey[200],
    cursor: "pointer"
  },

  "&.Mui-selected": {
    borderRadius: "6px !important",
    backgroundColor: theme.palette.secondary[100]
  },

  "&.Mui-selected:hover": {
    backgroundColor: theme.palette.secondary[200]
  }
}))

const DeviceListItem = ({ device }) => {
  const { activeMarker } = useContext(MapContext)
  const isActive = activeMarker && activeMarker.label === device.label

  return (
    <StyledListItem isActive={isActive} key={device.id} role={undefined}>
      <DeviceLabel device={device} />
      <DeviceStatus device={device} />
    </StyledListItem>
  )
}

export default DeviceListItem
